/**
 * PageHeader
 *
 * @author Dominique Rau [domi.github@gmail.com](mailto:domi.github@gmail.com)<br/>
 * @version 0.0.1
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/ChevronLeft';
import clsx from 'clsx';
import yoga from '@thingos/react-utils-yoga';
import { IconButtonLink } from './buttons';
// header
// ------------------------------
var usePageHeaderStyle = makeStyles(function (theme) { return ({
    root: __assign(__assign(__assign({ backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.paper : theme.palette.grey[50] }, yoga.row), yoga.align.center), yoga.justify.spaceBetween),
    title: __assign({ margin: '40px 64px' }, yoga.utils.row.center),
    hasBackButtonMargin: {
        marginLeft: 64 - 16 - 24 - 6,
    },
    divider: {
        borderBottom: "1px solid rgba(0,0,0,0.08)",
    },
}); });
export var PageHeader = function (_a) {
    var backTo = _a.backTo, divider = _a.divider, title = _a.title, children = _a.children, restProps = __rest(_a, ["backTo", "divider", "title", "children"]);
    var classes = usePageHeaderStyle(restProps);
    var hasBackButton = backTo != null;
    return (React.createElement("div", { className: clsx(classes.root, divider && classes.divider) },
        React.createElement("div", { className: clsx(classes.title, hasBackButton && classes.hasBackButtonMargin) },
            hasBackButton && (React.createElement(IconButtonLink, { size: "small", to: backTo, style: { marginRight: 16 }, variant: "outlined" },
                React.createElement(LockOutlinedIcon, null))),
            React.createElement(Typography, { variant: "h4", color: "textSecondary" }, title)),
        React.createElement("div", null, children)));
};
